import { withStyles } from '@material-ui/core/styles';
import Switch from './Switch';
import styles from './Switch.styles';

export default withStyles(styles)(Switch);
